import {defineStore} from "pinia";
import autobahn from "autobahn-browser";
import {EventEmitter} from "events";

export const crossbarStore = defineStore("crossbar", {
    state: () => ({
        emitter: new EventEmitter(),
        isInShop: false,
        settings: {},
        connection: null,
        session: null
    }),

    getters: {
        connected() {
            return this.session !== null;
        }
    },

    actions: {
        init(settings) {
            this.settings = settings;
        },

        connect() {
            if (this.connection !== null) return;

            const user = this.settings.user;
            const key = this.settings.key;

            const connection = new autobahn.Connection({
                url: this.settings.host,
                realm: this.settings.realm,
                max_retries: -1,
                authid: user,
                authmethods: ["wampcra"],
                max_retry_delay: 10,
                onchallenge: (session, method, extra) => {
                    console.log("onchallenge", method, extra);

                    if (method === "wampcra") {
                        return autobahn.auth_cra.sign(key, extra.challenge);
                    } else {
                        throw "don't know how to authenticate using '" + method + "'";
                    }
                }
            });

            connection.onopen = session => this.onConnectionOpen(session);

            connection.onclose = (reason, details) => {
                console.log("reden: " + reason);
                console.log("details: %j", details);
                this.offMessage();
            };

            connection.open();
            this.connection = connection;
        },

        reconnect() {
            this.connecton = null;
            this.connect();
        },

        disconnect() {
            console.log("disconnect in crossbar");
            if (this.connection) {
                this.offMessage();
                this.connection.close();
                this.connection = null;
            }
        },

        onConnectionOpen(session) {
            this.session = session;
            this.emit("connected");
        },

        publish(command, shopId, data = {}) {
            try {
                if (this.session !== null && this.isInShop) {
                    this.session.publish("cocon-command-" + shopId, null, {command, data});
                }
            } catch (error) {
                console.log("publish error: ", error);
            }
        },

        publishToDemoBed(command, shopId, data = {}) {
            try {
                if (this.session !== null && this.isInShop) {
                    this.session.publish("demobed-command-" + shopId, null, {command, data});
                }
            } catch (error) {
                console.log("publish to bed error: ", error);
            }
        },

        async onMessage(command, callback) {
            this.emitter.on(command, callback);
            this.command = command;

            this.subscription = await this.session.subscribe(command, (args, kwargs) => {
                const data = args.length > 0 ? args[0] : kwargs;
                this.emit(command, data);
            });
        },

        offMessage() {
            this.emitter.removeAllListeners(this.command);

            if (!this.session || !this.session.isOpen) return;

            this.session.unsubscribe(this.subscription).then(() => {
                console.log("Unsubscribed from topic:", subscription.topic);
            }, (err) => {
                console.log("Failed to unsubscribe:", err);
            });
        },

        on(command, callback) {
            this.emitter.on(command, callback);
        },

        off(command, callback) {
            this.emitter.off(command, callback);
        },

        emit(command, data) {
            this.emitter.emit(command, data);
        }
    }
});